import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, Teleport as _Teleport, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  key: 1,
  class: "revision-browser"
}
const _hoisted_3 = { class: "revision-browser__header" }
const _hoisted_4 = { class: "revision-browser__title-wrapper" }
const _hoisted_5 = { class: "h1 mb-32" }
const _hoisted_6 = { class: "revision-browser__toolbar" }
const _hoisted_7 = { class: "revision-browser__pips-container" }
const _hoisted_8 = { class: "revision-browser__revision-pips" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "revision-browser__pips-label" }, " Stage ", -1 /* HOISTED */)
const _hoisted_10 = ["onMouseover", "onClick"]
const _hoisted_11 = { key: 0 }
const _hoisted_12 = ["tabindex"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "revision-browser__pips-label" }, " Option ", -1 /* HOISTED */)
const _hoisted_14 = ["onMouseover", "onClick"]
const _hoisted_15 = { class: "revision-browser__feature-in-database" }
const _hoisted_16 = { class: "revision-browser__published-toggle" }
const _hoisted_17 = { class: "revision-browser__actions" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "revision-browser__permission-warning" }, " You do not have the required permissions to approve this image. ", -1 /* HOISTED */)
const _hoisted_20 = ["href"]
const _hoisted_21 = ["disabled"]
const _hoisted_22 = { class: "revision-browser__asset-switch" }
const _hoisted_23 = { class: "revision-browser__asset-switch-controls" }
const _hoisted_24 = {
  key: 0,
  class: "revision-browser__approval-banner-wrapper"
}
const _hoisted_25 = {
  key: 0,
  class: "revision-browser__approval-banner"
}
const _hoisted_26 = {
  key: 1,
  ref: "banner",
  class: "revision-browser__approval-banner revision-browser__approval-banner--approved"
}
const _hoisted_27 = {
  key: 2,
  ref: "banner",
  class: "revision-browser__approval-banner"
}
const _hoisted_28 = ["src", "alt"]
const _hoisted_29 = {
  key: 1,
  class: "revision-browser__option"
}
const _hoisted_30 = {
  key: 2,
  class: "iframe-container"
}
const _hoisted_31 = {
  key: 1,
  class: "revision-browser__revision revision-browser__revision--default"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "revision-browser__option revision-browser__option--default" }, null, -1 /* HOISTED */)
const _hoisted_33 = [
  _hoisted_32
]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_PageLoaderComponent = _resolveComponent("PageLoaderComponent")
  const _component_LightswitchComponent = _resolveComponent("LightswitchComponent")
  const _component_AddToDatabaseModalComponent = _resolveComponent("AddToDatabaseModalComponent")
  const _component_ApprovalModalComponent = _resolveComponent("ApprovalModalComponent")
  const _component_VideoOptionComponent = _resolveComponent("VideoOptionComponent")
  const _component_TourOptionComponent = _resolveComponent("TourOptionComponent")
  const _component_UploadModalComponent = _resolveComponent("UploadModalComponent")
  const _component_GalleryModalComponent = _resolveComponent("GalleryModalComponent")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          ($data.loading)
            ? (_openBlock(), _createBlock(_component_PageLoaderComponent, { key: 0 }))
            : ($data.asset)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("h1", _hoisted_5, _toDisplayString($data.asset.title), 1 /* TEXT */),
                      ($data.project.project_status !== 'completed' && $data.project.project_status !== 'terminated' && !$options.final_revision && $options.user_is_staff)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "button mt-8",
                            onClick: _cache[0] || (_cache[0] = $event => ($data.show_upload_modal = !$data.show_upload_modal))
                          }, " Add media "))
                        : _createCommentVNode("v-if", true)
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _hoisted_9,
                          ($options.contentful_revisions.length)
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($options.contentful_revisions, (revision) => {
                                return (_openBlock(), _createElementBlock("button", {
                                  key: 'revision-pip-' + revision.id,
                                  class: _normalizeClass(["revision-browser__revision-pip", [
											{ 'revision-browser__revision-pip--selected': $options.isSelectedRevision( revision ) },
											{ 'revision-browser__revision-pip--active': $options.isActiveRevision( revision ) },
											$options.getRevisionPipClass( revision )
										]]),
                                  onMouseover: $event => ($options.mouseOverRevision( revision )),
                                  onMouseleave: _cache[1] || (_cache[1] = $event => ($data.visible_revision = null)),
                                  onClick: $event => ($options.selectRevision( revision ))
                                }, [
                                  _createElementVNode("span", null, _toDisplayString(revision.revision_number), 1 /* TEXT */),
                                  ($options.final_revision && $options.final_revision.id === revision.id)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, " C "))
                                    : _createCommentVNode("v-if", true)
                                ], 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_10))
                              }), 128 /* KEYED_FRAGMENT */))
                            : _createCommentVNode("v-if", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.future_stages, (stage) => {
                            return (_openBlock(), _createElementBlock("button", {
                              key: stage,
                              disabled: true,
                              class: "revision-browser__revision-pip revision-browser__revision-pip--future-stage"
                            }, [
                              _createElementVNode("span", null, _toDisplayString(stage), 1 /* TEXT */)
                            ]))
                          }), 128 /* KEYED_FRAGMENT */)),
                          _createCommentVNode(" To be added in the future "),
                          _createCommentVNode(" <div class=\"revision-browser__info\">\n\t\t\t\t\t\t\t\t\t<div\n\t\t\t\t\t\t\t\t\t\tclass=\"revision-browser__info-icon\"\n\t\t\t\t\t\t\t\t\t\t@mouseover=\"show_info_text = true\"\n\t\t\t\t\t\t\t\t\t\t@mouseleave=\"show_info_text = false\"\n\t\t\t\t\t\t\t\t\t/>\n\t\t\t\t\t\t\t\t\t<p\n\t\t\t\t\t\t\t\t\t\tclass=\"revision-browser__info-text\"\n\t\t\t\t\t\t\t\t\t\t:class=\"{ 'revision-browser__info-text--reveal': show_info_text }\"\n\t\t\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t\t\t\t{{ info_text }}\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t</div> ")
                        ]),
                        _createElementVNode("div", {
                          class: _normalizeClass(["revision-browser__options-wrapper", { 'revision-browser__options-wrapper--hide-options': $data.selected_revision && $data.selected_revision.revision_options.length < 2 }])
                        }, [
                          ($data.selected_revision)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "revision-browser__option-pips",
                                tabindex: $data.selected_revision.revision_options.length < 2 ? -1 : 0
                              }, [
                                _hoisted_13,
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.selected_revision.revision_options, (option) => {
                                  return (_openBlock(), _createElementBlock("button", {
                                    key: 'revision-option-pip-' + option.id,
                                    class: _normalizeClass(["revision-browser__option-pip", [
											{ 'revision-browser__option-pip--selected': $options.isSelectedOption( option ) },
											{ 'revision-browser__option-pip--active': $options.isActiveOption( option ) },
											{ 'revision-browser__option-pip--approved': $options.isClientApprovedOption( option ) },
											{ 'revision-browser__option-pip--unapproved': $options.isStaffUnapprovedOption( option ) },
										]]),
                                    onMouseover: $event => ($options.mouseOverOption( option )),
                                    onMouseleave: _cache[2] || (_cache[2] = $event => ($data.visible_option = null)),
                                    onClick: $event => ($options.selectOption( option ))
                                  }, [
                                    _createElementVNode("span", null, _toDisplayString(option.option_number), 1 /* TEXT */)
                                  ], 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_14))
                                }), 128 /* KEYED_FRAGMENT */))
                              ], 8 /* PROPS */, _hoisted_12))
                            : _createCommentVNode("v-if", true),
                          ($options.show_database_button)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createElementVNode("div", _hoisted_15, [
                                  _createElementVNode("button", {
                                    class: "button button--smaller",
                                    onClick: _cache[3] || (_cache[3] = $event => ($data.show_database_modal = true))
                                  }, _toDisplayString($options.feature_in_database_label), 1 /* TEXT */)
                                ]),
                                _createElementVNode("div", _hoisted_16, [
                                  _createVNode(_component_LightswitchComponent, {
                                    label: "Published",
                                    "off-label": "Published",
                                    checked: $data.selected_option.published,
                                    disabled: $data.loading,
                                    onChange: _cache[4] || (_cache[4] = value => $options.toggleSelectedOptionAsPublished( value ))
                                  }, null, 8 /* PROPS */, ["checked", "disabled"])
                                ]),
                                (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
                                  _createVNode(_Transition, { name: "fade" }, {
                                    default: _withCtx(() => [
                                      ($data.show_database_modal)
                                        ? (_openBlock(), _createBlock(_component_AddToDatabaseModalComponent, {
                                            key: 0,
                                            option: $data.selected_option,
                                            project: $data.project,
                                            "base-asset-type": $options.base_asset_type,
                                            mode: $data.selected_option.include_in_database ? 'remove' : 'add',
                                            onConfirm: $options.toggleInclusionInDatabaseOption,
                                            onCloseModal: _cache[5] || (_cache[5] = $event => ($data.show_database_modal = false)),
                                            onCloseModalAndRefreshData: $options.closeDatabaseModalAndRefreshData
                                          }, null, 8 /* PROPS */, ["option", "project", "base-asset-type", "mode", "onConfirm", "onCloseModalAndRefreshData"]))
                                        : _createCommentVNode("v-if", true)
                                    ]),
                                    _: 1 /* STABLE */
                                  })
                                ]))
                              ], 64 /* STABLE_FRAGMENT */))
                            : _createCommentVNode("v-if", true)
                        ], 2 /* CLASS */)
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        ($data.selected_option)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              ($data.project.project_status !== 'completed' && $data.project.project_status !== 'terminated' && ( $options.user_is_staff && !$options.option_is_staff_approved ))
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: _normalizeClass(["revision-browser__approve-button-wrapper", { 'revision-browser__approve-button-wrapper--show-permission-warning': !$options.user_has_staff_approval_permission }])
                                  }, [
                                    _createElementVNode("button", {
                                      class: _normalizeClass(["revision-browser__approve-button", [
											{ 'revision-browser__approve-button--loading': $data.loading_approval }
										]]),
                                      disabled: !$options.user_has_staff_approval_permission,
                                      onClick: _cache[6] || (_cache[6] = $event => ($data.show_approval_modal = true))
                                    }, _toDisplayString($options.approval_title), 11 /* TEXT, CLASS, PROPS */, _hoisted_18),
                                    _hoisted_19
                                  ], 2 /* CLASS */))
                                : ($options.user_is_client && $options.final_revision && ( $data.selected_revision.id === $options.final_revision.id && $data.selected_revision.revision_number === $options.final_revision.revision_number ))
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 1,
                                      class: "revision-browser__download-button",
                                      href: $options.selected_option_download_url
                                    }, " Download final " + _toDisplayString($data.selected_option.video_url ? 'video' : 'image'), 9 /* TEXT, PROPS */, _hoisted_20))
                                  : ($data.project.project_status !== 'completed' && $data.project.project_status !== 'terminated' && ( $options.user_is_client && ( !$options.final_revision || $options.option_is_client_approved ) || ( $options.user_has_client_approval_permission && !$options.final_revision && $options.stage_is_b && $options.stage_is_last ) ))
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 2,
                                        class: _normalizeClass(["revision-browser__approve-button", [
										{ 'revision-browser__approve-button--loading': $data.loading_approval },
										{ 'revision-browser__approve-button--approved': $options.option_is_client_approved }
									]]),
                                        disabled: $options.option_is_client_approved || !$options.user_has_client_approval_permission,
                                        onClick: _cache[7] || (_cache[7] = $event => ($data.show_approval_modal = true))
                                      }, _toDisplayString($options.approval_title), 11 /* TEXT, CLASS, PROPS */, _hoisted_21))
                                    : _createCommentVNode("v-if", true)
                            ], 64 /* STABLE_FRAGMENT */))
                          : _createCommentVNode("v-if", true),
                        (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
                          _createVNode(_Transition, { name: "fade" }, {
                            default: _withCtx(() => [
                              ($data.show_approval_modal)
                                ? (_openBlock(), _createBlock(_component_ApprovalModalComponent, {
                                    key: 0,
                                    type: $options.approval_type,
                                    revision: $data.selected_revision,
                                    option: $data.selected_option,
                                    onCloseModal: _cache[8] || (_cache[8] = $event => ($data.show_approval_modal = false)),
                                    onApproveFinalRevision: $options.approveSelectedRevision,
                                    onApprove: $options.approveSelectedOption
                                  }, null, 8 /* PROPS */, ["type", "revision", "option", "onApproveFinalRevision", "onApprove"]))
                                : _createCommentVNode("v-if", true)
                            ]),
                            _: 1 /* STABLE */
                          })
                        ])),
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("button", {
                              class: _normalizeClass(["revision-browser__asset-switch-button--prev", { 'revision-browser__asset-switch-button--disabled': !$options.can_navigate_to_prev_asset }]),
                              onClick: _cache[9] || (_cache[9] = (...args) => ($options.goToPrevAsset && $options.goToPrevAsset(...args)))
                            }, null, 2 /* CLASS */),
                            _createElementVNode("button", {
                              class: _normalizeClass(["revision-browser__asset-switch-button--next", { 'revision-browser__asset-switch-button--disabled': !$options.can_navigate_to_next_asset }]),
                              onClick: _cache[10] || (_cache[10] = (...args) => ($options.goToNextAsset && $options.goToNextAsset(...args)))
                            }, null, 2 /* CLASS */)
                          ])
                        ])
                      ])
                    ])
                  ]),
                  ($data.selected_option)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        _createVNode(_Transition, { name: "banner" }, {
                          default: _withCtx(() => [
                            ($data.asset.asset_status && ['paused', 'cancelled'].includes( $data.asset.asset_status ))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_25, " This asset has been " + _toDisplayString($data.asset.asset_status), 1 /* TEXT */))
                              : ($data.show_approved_banner)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_26, " Approved ", 512 /* NEED_PATCH */))
                                : ($options.show_unapproved_banner)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                      ($data.selected_revision.revision_options.length > 1)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createTextVNode(" Greyed out options are not visible to client. " + _toDisplayString($options.user_has_staff_approval_permission ? 'Please approve any unapproved options.' : 'Awaiting approval.'), 1 /* TEXT */)
                                          ], 64 /* STABLE_FRAGMENT */))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            _createTextVNode(" Upload not visible to client. " + _toDisplayString($options.user_has_staff_approval_permission ? 'Please approve upload.' : 'Awaiting approval.'), 1 /* TEXT */)
                                          ], 64 /* STABLE_FRAGMENT */))
                                    ], 512 /* NEED_PATCH */))
                                  : _createCommentVNode("v-if", true)
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]))
                    : _createCommentVNode("v-if", true),
                  _createVNode(_Transition, { name: "fade" }, {
                    default: _withCtx(() => [
                      ($options.active_option)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            ref: "revision-image-container",
                            class: _normalizeClass(["revision-browser__revision", { 'revision-browser__revision--with-banner': $data.show_approved_banner || $options.show_unapproved_banner }]),
                            onMousemove: _cache[14] || (_cache[14] = (...args) => ($options.setCursorHoverStyles && $options.setCursorHoverStyles(...args)))
                          }, [
                            ($options.active_option.image_large_url)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  (_openBlock(), _createElementBlock("img", {
                                    ref: "revision-image",
                                    key: `image-${$options.active_option.id}`,
                                    class: "revision-browser__option revision-browser__option--image",
                                    src: $options.active_option.image_large_url,
                                    alt: $options.active_option.title,
                                    onMouseenter: _cache[11] || (_cache[11] = $event => ($data.show_cursor = true)),
                                    onMouseleave: _cache[12] || (_cache[12] = $event => ($data.show_cursor = false)),
                                    onClick: _cache[13] || (_cache[13] = (...args) => ($options.openGallery && $options.openGallery(...args)))
                                  }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_28)),
                                  _createElementVNode("span", {
                                    class: _normalizeClass(["revision-browser__fullscreen-cursor", { 'revision-browser__fullscreen-cursor--show': $data.show_cursor }]),
                                    style: _normalizeStyle($options.cursor_styles)
                                  }, null, 6 /* CLASS, STYLE */)
                                ], 64 /* STABLE_FRAGMENT */))
                              : ($options.active_option.video_url)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                    (_openBlock(), _createBlock(_component_VideoOptionComponent, {
                                      key: $options.active_option.id,
                                      option: $options.active_option,
                                      "commenting-disabled": $data.project.project_status === 'completed' || $data.project.project_status === 'terminated' || !!$options.final_revision || !$options.stage_is_last
                                    }, null, 8 /* PROPS */, ["option", "commenting-disabled"]))
                                  ]))
                                : ($options.active_option.tour_id)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                      (_openBlock(), _createBlock(_component_TourOptionComponent, {
                                        key: 'explore-' + $options.active_option.id,
                                        option: $options.active_option
                                      }, null, 8 /* PROPS */, ["option"]))
                                    ]))
                                  : _createCommentVNode("v-if", true)
                          ], 34 /* CLASS, HYDRATE_EVENTS */))
                        : (_openBlock(), _createElementBlock("div", _hoisted_31, _hoisted_33))
                    ]),
                    _: 1 /* STABLE */
                  })
                ]))
              : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      })
    ]),
    ($data.project && $data.asset)
      ? (_openBlock(), _createBlock(_component_UploadModalComponent, {
          key: 0,
          show: $data.show_upload_modal,
          project: $data.project,
          asset: $data.asset,
          onCloseModal: $options.closeUploadModal
        }, null, 8 /* PROPS */, ["show", "project", "asset", "onCloseModal"]))
      : _createCommentVNode("v-if", true),
    (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          ($data.gallery_images && $data.gallery_images.length && $data.show_gallery_modal)
            ? (_openBlock(), _createBlock(_component_GalleryModalComponent, {
                key: 0,
                options: $data.gallery_images,
                onCloseModal: $options.closeGalleryModal
              }, null, 8 /* PROPS */, ["options", "onCloseModal"]))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      })
    ]))
  ], 64 /* STABLE_FRAGMENT */))
}